import { useQuery } from '@tanstack/react-query'
import { PokemonResponse, PokemonDetail } from '@/types/pokemon'

const POKEMON_PER_PAGE = 5

export function useGetPokemons(page = 1) {
  const offset = (page - 1) * POKEMON_PER_PAGE

  const query = useQuery<PokemonResponse>({
    queryKey: ['pokemon', 'list', page],
    queryFn: async () => {
      const response = await fetch(
        `https://pokeapi.co/api/v2/pokemon?limit=${POKEMON_PER_PAGE}&offset=${offset}`
      )
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    },
  })

  return {
    ...query,
    hasNextPage: !!query.data?.next,
    hasPreviousPage: !!query.data?.previous,
  }
}

export function useGetPokemonDetail(name: string) {
  return useQuery<PokemonDetail>({
    queryKey: ['pokemon', 'detail', name],
    queryFn: async () => {
      const response = await fetch(`https://pokeapi.co/api/v2/pokemon/${name}`)
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    },
    enabled: !!name, // Only fetch when name is provided
  })
} 
